import React, { Fragment, useRef, useState , useEffect, useContext} from 'react'
import { Dialog, Transition } from '@headlessui/react'
// import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { CheckIcon, SettingIcon, ThemeIcon } from './Icons'
import { Theme } from './Theme';
import { ThemeContext } from '../App';

export default function Settings({setTheme, setAttempts, setPegsInRow, setSettings, setLevel, restartGame}) {
  const [open, setOpen] = useState(true)
  const currentTheme = useContext(ThemeContext);
  const [isLightTheme, setLightTheme] = useState(currentTheme.mode === "light");

  // useEffect(() => {
  //   if(isLightTheme){
  //     setTheme(Theme.White);
  //     localStorage.setItem('theme', JSON.stringify(Theme.White));
  //   } else {
  //     setTheme(Theme.Black);
  //     localStorage.setItem('theme', JSON.stringify(Theme.Black));
  //   }
  // }, [isLightTheme])
  
  const cancelButtonRef = useRef(null)

  const Difficulty = [
    {
        title: "Easy",
        pegsInRow:3,
        attempts: 10,
        bgColor: "bg-emerald-700"
    },
    {
        title: "Medium",
        pegsInRow:4,
        attempts: 10,
        bgColor: "bg-amber-500"
    },
    {
        title: "Hard",
        pegsInRow:5,
        attempts: 10,
        bgColor: "bg-red-900"
    },
  ]

  const updateSettings = (level) => {
    // setAttempts(level.attempts);
    // setPegsInRow(level.pegsInRow);
    // setSettings(false);
    localStorage.setItem('level', JSON.stringify(level));
    setLevel(level);
    restartGame();
    setSettings(false);
    // window.location.reload();
  }

  const updateTheme = (themeName) => {
    setTheme(Theme[themeName]);
    if(Theme[themeName]){
      localStorage.setItem('theme', JSON.stringify(Theme[themeName]));
    }
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className={`relative transform overflow-hidden rounded-lg ${currentTheme.backgroundColor} ${currentTheme.foregroundColor}  text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg`}>
                <div className="px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <SettingIcon size = "44px" className='xs:mx-auto sm:ml-4 ' />
                  <div className="sm:flex sm:items-start">
                    {/* <div onClick={() => updateTheme(isLightTheme ? "Black" : "White")} className={`mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10 ${isLightTheme ? "bg-indigo-200" : "bg-indigo-300"}`}>
                        <ThemeIcon fillColor= {isLightTheme ? "#4338ca" : "#fff"} strokeWidth = {0} height ={"32px"} width = {"32px"}/>
                    </div> */}
                    {/* <Dialog.Title as="h3" className={`text-base font-semibold leading-6 ${currentTheme.foregroundColor}`}>
                      Settings
                    </Dialog.Title> */}
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                      <div className="mt-4">
                        <p className="text-sm font-bold">
                          Difficulty Level
                        </p>
                        {Difficulty.map((level, idx) => {
                            return(
                                <button
                                    key = {idx}
                                    type="button"
                                    className={`inline-flex w-2/3 justify-center rounded-md ${level.bgColor} px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-purple-500 sm:mr-3 sm:w-auto mb-4`}
                                    onClick={() => updateSettings(level)}
                                >
                                    {level.title}
                                </button>
                            )
                        })}
                      </div>
                      <div className="mt-4">
                        <p className="text-sm font-bold">
                          Change Theme
                        </p>
                        <div className='grid grid-cols-4 gap-1'>
                          {Object.keys(Theme).map((theme, idx) => {
                              return(
                                  <button
                                      key = {idx}
                                      type="button"
                                      className={`inline-flex items-center w-full justify-center rounded-md ${Theme[theme].backgroundColor} px-3 py-2 text-xs font-semibold ${Theme[theme].foregroundColor} shadow-lg ${currentTheme.backgroundColor === Theme[theme].backgroundColor ? currentTheme.mode === 'light' ? "border-2 border-black" : "border-2 border-white" : "" }`}
                                      onClick={() => updateTheme(theme)}
                                      // style = { {border: "2px #fff solid"}}
                                  >
                                      {currentTheme.backgroundColor === Theme[theme].backgroundColor && <CheckIcon fillColor='#000' strokeColor='#fff' strokeWidth={"2"} size={'14px'}/>}{theme}
                                  </button>
                              )
                          })}

                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                <div className="px-4 py-2 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="mt-2 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => setSettings(false)}
                    ref={cancelButtonRef}
                  >
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
